var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWilmaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2432,
    height: 680,
    viewBox: "0 0 2432 680",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M565.462 203.53L477.359 494.193L389.093 203.53H288.545L200.278 494.193L112.175 203.53H0L151.314 665.844H251.044L339.146 387.605L426.43 665.844H526.16L676.655 203.53H565.298H565.462Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M788.339 204.348V666.662H899.695V204.348H788.339Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M955.699 9.15527e-05V666.824H1067.06V9.15527e-05H955.699Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1796.77 239.657C1762.38 206.962 1718.33 190.614 1664.94 190.614C1599.11 190.614 1549.82 215.79 1517.06 266.304C1484.48 215.953 1435.68 190.614 1370.99 190.614C1316.3 190.614 1272.9 211.376 1240.97 252.899V204.019H1129.61V666.333H1240.97V394.307C1240.97 366.352 1250.3 343.139 1268.97 324.502C1287.64 305.866 1310.73 296.384 1337.91 296.384C1365.1 296.384 1388.19 305.702 1406.53 324.502C1425.03 343.139 1434.04 366.352 1434.04 394.307V666.333H1545.4V394.307C1545.4 366.352 1554.73 343.139 1573.4 324.502C1592.07 305.866 1615.16 296.384 1642.34 296.384C1669.53 296.384 1692.62 305.702 1710.96 324.502C1729.46 343.139 1738.63 366.352 1738.63 394.307V555.005H1849.01V666.333V362.265C1849.01 313.713 1831.48 272.68 1796.44 239.657H1796.77Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2321.46 204.186V240.641C2279.87 207.455 2233.03 190.781 2180.79 190.781C2116.6 190.781 2062.89 214.321 2019.65 261.076C1976.91 307.34 1955.46 365.374 1955.46 435.343C1955.46 505.311 1976.91 563.672 2019.65 610.427C2063.54 656.691 2117.25 679.741 2180.79 679.741C2233.03 679.741 2280.03 663.23 2321.46 630.044V666.5H2432V204.186H2321.46ZM2283.14 530.486C2259.4 555.989 2230.08 568.577 2195.04 568.577C2159.99 568.577 2129.7 555.989 2105.95 530.486C2082.21 504.984 2070.42 473.269 2070.42 435.343C2070.42 397.416 2082.37 365.701 2105.95 340.199C2129.7 314.696 2159.5 301.945 2195.04 301.945C2230.58 301.945 2259.4 314.696 2283.14 340.199C2307.54 366.192 2319.66 397.906 2319.66 435.343C2319.66 472.779 2307.54 504.33 2283.14 530.486Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M788.183 92.6931H676.499V204.185H788.183V92.6931Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1960.85 554.842H1849.17V666.333H1960.85V554.842Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWilmaLogo);
export default __webpack_public_path__ + "static/media/wilma-logo.8e139a855736b38253d569cbb69cadfb.svg";
export { ForwardRef as ReactComponent };